import React, { useCallback } from "react";
import { Button } from "@jsq/ds/core";
import { extractOAuthChallenge } from "../oauthHandoff";
import * as styles from "./styles_vanilla.css";

type SSOButtonProps = {
  providerName: string;
};

export const SSOButton: React.FC<SSOButtonProps> = ({ providerName }) => {
  const handleSSOSignIn = useCallback(() => {
    // If we're mid OAuth login handoff, the challenge must survive the SSO
    // round-trip. /login/oauth-handoff is POST-only, so wrap the target through
    // /login: after SSO the monolith redirects there, and (now authenticated)
    // it bounces to /canopy/login?path=... where Canopy completes the
    // CSRF-protected handoff. Mirrors the monolith apps/login SSO flow.
    const path = new URLSearchParams(window.location.search).get("path");
    if (path && extractOAuthChallenge(path)) {
      const wrapped = `/login?path=${encodeURIComponent(path)}`;
      window.location.href = `/sso?path=${encodeURIComponent(wrapped)}`;
      return;
    }
    window.location.href = "/sso";
  }, []);

  return (
    <Button
      variant="primary"
      isFullWidth
      onClick={handleSSOSignIn}
      className={styles.ssoButton}
    >
      {`Sign in with ${providerName}`}
    </Button>
  );
};
